var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueDialog',{attrs:{"dialog-data":_vm.dialogData}},[_c('vue-table',{attrs:{"table-data":_vm.tableData,"size":"mini"},scopedSlots:_vm._u([{key:"openid",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.openid ? "是" : "否")+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }